import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="container-pad py-32 text-center">
      <div className="overline">404</div>
      <h1 className="font-display text-6xl text-navy mt-4 tracking-tight">Page not found</h1>
      <p className="text-muted2 mt-4 max-w-md mx-auto">
        The page you're looking for has moved or doesn't exist.
      </p>
      <Link to="/" data-testid="notfound-home" className="btn-ochre mt-10 inline-flex">
        <ArrowLeft size={16} /> Back to home
      </Link>
    </div>
  );
}
